import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/_authenticated/warehouse/')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirects are thrown response objects.
    throw redirect({ to: '/$locale/warehouse/inventory', params: { locale: params.locale } });
  },
});
